import {
    AutoRefreshTokenService,
    createInterceptorCondition,
    INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
    IncludeBearerTokenCondition,
    provideKeycloak,
    UserActivityService,
    withAutoRefreshToken
  } from 'keycloak-angular';
  
  import { environment } from '../../environments/environment';
  
  const urlPatternEscaped = '';
  
  const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: /.*/i,
    bearerPrefix: 'Bearer',
  });
  
  export const provideKeycloakAngular = () =>
    provideKeycloak({
      config: {
        url: environment.keycloak.url,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId,
      },
      initOptions: {
        onLoad: 'login-required',
        enableLogging: true,
      },
      features: [
        withAutoRefreshToken({
          onInactivityTimeout: 'logout',
          sessionTimeout: 5*60*60*1000
        })
      ],
      providers: [
        AutoRefreshTokenService,
        UserActivityService,
        {
          provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
          useValue: [urlCondition],
        },
      ],
    });
  